<template>
  <SlotButton :to="to" :text="text" @mouseover="changeIcon" @mouseleave="changeIcon">
    <!-- lock -->
    <transition name="scale-in">
      <AppIcon v-if="!unlock" icon="fal fa-lock-alt" />
    </transition>
    <!-- unlock -->
    <transition name="scale-in">
      <AppIcon v-if="unlock" icon="fal fa-unlock-alt" />
    </transition>
  </SlotButton>
</template>

<script>
// Components
import AppIcon from 'Ui/AppIcon'
import SlotButton from 'Components/SlotButton'
export default {
  name: 'SlotButtonLock',
  components: {
    AppIcon,
    SlotButton,
  },
  props: {
    to: {
      type: Object,
      default: () => {
        return {}
      },
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      unlock: false,
    }
  },
  methods: {
    changeIcon() {
      this.unlock = !this.unlock
    },
  },
}
</script>

<style scoped></style>
